/*
 * @Author: yangfan
 * @Date: 2022-01-21 17:11:15
 * @LastEditTime: 2022-01-21 17:11:15
 * @LastEditors: yangfan
 * @Description: 被保人列表
 */
import React from 'react';
import classnames from 'classnames';
export { default as InsuredPlanSelect } from './components/PlanSelect';
export { default as InsuredWithPlanSelect } from './components/InsuredList';

const InsuredListWithPlanClauseModule = (props = {}) => {
  const {
    id,
    Render,
    children
  } = props;
  const cls = classnames({// 'components-tabs-module-render': true,
  });
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cls
  }, /*#__PURE__*/React.createElement(Render, {
    components: children
  }));
};

export default InsuredListWithPlanClauseModule;